import { render, staticRenderFns } from "./payWallCard.vue?vue&type=template&id=78535f62&scoped=true"
import script from "./payWallCard.vue?vue&type=script&lang=js"
export * from "./payWallCard.vue?vue&type=script&lang=js"
import style0 from "./payWallCard.vue?vue&type=style&index=0&id=78535f62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78535f62",
  null
  
)

export default component.exports